import _ from 'lodash';
import React from 'react';
import { useHistory } from 'react-router-dom';
import Crud from '~/components/crud';
import useReportsIp from '~/view-data/use-reports-ip';
import { Container } from '~/views/reports/styles';

const columns = [
  {
    name: 'Contrato',
    selector: 'groupName',
    width: '200px',
    cell: row => <strong>{row.groupName}</strong>,
  },
  {
    name: 'Nº Contrato',
    selector: 'controlContractNumber',
    width: '85px',
    cell: row => row.controlContractNumber,
  },
  {
    name: 'Parceiro',
    selector: 'partner',
    width: '240px',
    cell: row => _.get(row, 'partner.name'),
  },
  {
    name: 'DDNS',
    selector: 'ddns',
    width: '240px',
    cell: row => (Array.isArray(row.ddns) && row.ddns.length > 0
      ? row.ddns.join(', ')
      : <span style={{ color: '#888' }}>Nenhum cadastrado</span>),
  },
  {
  name: 'IPs',
  selector: 'ips',
  cell: row => {
    const ips = Array.isArray(row.ips) ? row.ips.join(', ') : '';

    return (
      <div
        className="ips-cell"
        style={{
          padding: '5px 0',
          maxHeight: '80px',
          overflowY: 'auto',
          whiteSpace: 'normal',
          wordBreak: 'break-all',
        }}
      >
        {ips || <span style={{ color: '#888' }}>Nenhum cadastrado</span>}
      </div>
    );
  },
},
];

function ReportsIp() {
  const { state, actions } = useReportsIp();
  const history = useHistory();

  const handleRowClick = (row) => {
    const contractId = row.id;
    if (contractId) {
      history.push(`/partners/${_.get(row, 'partner.name')}`);
    } else {
      alert('Contrato não encontrado para esta linha.');
    }
  };

  return (
  <Container>
    <style>
  {`
    .rdt_TableRow {
      min-height: 100px !important;
    }

    /* volta as outras colunas ao normal */
    .rdt_TableCell {
      align-items: center !important;
    }

    /* só a coluna IP fica no topo */
    .ips-cell {
      display: flex;
      align-items: flex-start;
      height: 100%;
    }
  `}
</style>

    <Crud
      columns={columns}
      formTitle={() => 'Lista de Endereços IP/DDNS'}
      emptyText="Nenhum contrato com IP/DDNS encontrado"
      data={state.data || { rows: [] }}
      tableLoading={state.loading}
      onChangePage={actions.pageChange}
      hideAdd={true}
      onRowClicked={handleRowClick}
      disableRowClick={false}
    />
  </Container>
);
}

export default ReportsIp;
